interface CreateNotificationOpts {
  type: "success" | "warning" | "error" | "info";
  message: string;
  duration: number;
}

const svgCheck = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" class="svg-inline--fa fa-check-circle fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"/></svg>`;
const svgTimes = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle" className="svg-inline--fa fa-exclamation-circle fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"/></svg>`;

class GNotifications {

  container?: HTMLDivElement;
  ready?: boolean;

  constructor() {
    if (typeof window === "undefined") return;
    this.container = document.createElement("div");
    this.container.id = "gn-container";
    this.container.className = `gn-container`;
    document.getElementsByTagName("body")[0].appendChild(this.container);
    this.ready = true;
  }

  add = (opts: CreateNotificationOpts) => {
    if (this.container) {
      const div = this.messageElement(opts);
      this.container.appendChild(div);
      setTimeout(() => {
        div.classList.add("visible");
        setTimeout(() => {
          this.removeMessage(div);
        }, opts.duration);
      }, 100);
    }
  }

  clear = () => {
    if (this.container) {
      this.container.innerHTML = "";
    }
  }
  
  messageElement = (opts: CreateNotificationOpts) => {
    const div = document.createElement("div");
    div.addEventListener("click", () => {
      this.removeMessage(div);
    });
    div.className = `gn-notification ${opts.type} text-center shadow-1`;

    if (opts.type === "success" || opts.type === "error") {
      const icon = opts.type === "success" ? svgCheck : svgTimes;
      div.innerHTML = `<span class="flex-line centered">${icon}${opts.message}</span>`;
    }
    else {
      div.innerHTML = opts.message;
    }

    return div;
  }
  
  removeMessage = (div: HTMLDivElement) => {
    if (div) {
      div.classList.remove("visible");
      setTimeout(() => {
        if (div.parentNode) {
          div.parentNode.removeChild(div);
        }
      }, 350);
    }
  }

}

export const GN = new GNotifications();
